<template>
  <div class="draw_scroll" ref="scrollWrap">
    <div class="draw_list"
         v-infinite-scroll="loadMore"
         infinite-scroll-immediate="false"
         v-if="!isLogin||draw_list.length==0">
      <div class="draw_list_item"
           v-for="(item,index) in sampleSysList"
           :key="index">
        <div class="text">
          <div class="title flex jb">
            <div class="info flex ac">
              <img src="./img/sora_logo.gif" class="avatar"/>
              <div>
                <p style="margin-bottom: 3px">
                  <span class="topic">{{ sora_model==2?'Sora2 Pro':'Sora2' }}</span>
                  <span class="tag">示例</span>
                </p>
                <p>
                  <span class="time">{{ item.add_time }}</span>
                </p>
              </div>
            </div>
            <div class="flex ac">
              <p class="delete flex ac"
                 @click="sample_btn('del')">
                <i class="el-icon-delete"></i><span>删除</span>
              </p>
              <p class="delete flex ac"
                 @click="downloadVideo('sample')">
                <i class="el-icon-download"></i><span>下载</span>
              </p>
              <p class="delete flex ac"
                 @click="sample_btn('put')">
                <i class="el-icon-position" style="font-size: 14px"></i><span>推荐广场</span>
              </p>
            </div>
          </div>
          <div class="desc">
            <p class="zh">{{ item.text_prompt_cn }}</p>
            <p class="en">{{ item.text_prompt }}</p>
          </div>
          <template v-if="item.status < 2">
            <!-- 绘画 中 -->
            <div class="detail_loading msg-item-content">
              <circleloading></circleloading>
              <div class="loading_text">
                正在全力生成视频中，请稍等...
                <span v-if="item.progress >0">{{ item.progress }}%</span>
              </div>
            </div>
          </template>
          <div v-if="item.status == 2" style="margin: 10px 0 0 0;" class="success_shouVideo">
            <video controls controlslist="nodownload"
                   style="background-color:black;"
                   :poster="item.cover_url"
                   preload="none"
                   :src="item.video_url"
                   @play="handlePlay(index)"
                   ref="videoPlayers">
            </video>
          </div>
        </div>
      </div>
    </div>

    <div class="draw_list"
         v-infinite-scroll="loadMore"
         :infinite-scroll-disabled="loading">
      <div class="draw_list_item"
           v-for="(item,index) in draw_list"
           :key="index">
        <div class="text">
          <div class="title flex jb">
            <div class="info flex ac">
              <img src="./img/sora_logo.gif" class="avatar"/>
              <div>
                <p style="margin-bottom: 3px">
                  <span class="topic">{{ sora_model==2?'Sora2 Pro':'Sora2' }}</span>
                  <span class="tag"> {{ item.img_url == "" ? '文生视频' : '图生视频' }}</span>
                </p>
                <p>
                  <span class="time">{{ item.add_time }}</span>
                </p>
              </div>
              <!--              <span class="tag"> {{ item.img_url == "" ? '文生视频' : '图生视频' }}</span>-->
              <!--              <span class="time">{{ item.add_time.substring(5) }}</span>-->
            </div>
            <div class="top_right">
              <div @click="deleteVideo(index, item)" type="text">
                <i class="el-icon-delete"></i>删除
              </div>
              <div @click="downloadVideo(item)"
                   v-if="item.status == 2"
                   style="margin-left: 5px" type="text">
                <i class="el-icon-download" style="font-size: 14px"></i>下载
              </div>
              <div v-if="item.status == 2">
                <div style="margin-left: 5px" v-if="item.is_public==0||item.is_public==null"
                     @click="recommend(item.id,index)">
                  <i class="el-icon-position" style="font-size: 14px"></i> 推荐广场
                </div>
                <div style="margin-left: 5px" v-else>
                  <i class="el-icon-position" style="font-size: 14px"></i> 已推荐到广场
                </div>
              </div>
            </div>
          </div>

          <div class="desc">
            <p class="zh">{{ item.text_prompt_cn }}</p>
            <p class="en">{{ item.text_prompt }}</p>
          </div>
          <div class="create_error" v-loading="item.regenLoading > 0"
               v-if="item.status == 3">
            <!-- 绘画 失败 -->
            <img class="error_icon"
                 src="../../views/img/image_error.png"
                 alt="">
            <div class="error_text">很遗憾，生成失败 !</div>
            <div class="error_btn"
                 v-if="item.retry_num>=3 || item.is_retry!=0"
                 @click="showDefeatPopup">查看失败原因
            </div>
            <div class="error_new_btn" v-if="item.retry_num<3 && item.is_retry==0"
                 @click="error_new_fn(item.id,index)">
              点此重新生成<br/><span class="err_succ_text">（成功率90%以上）</span>
            </div>
            <div class="err_new_tip" v-if="item.show_error">
              失败原因： <span style="color:red;">{{ item.show_error }}</span>
            </div>
            <div class="err_new_tip" v-else>
              涉政、涉黄等请勿提交，会封号。其他问题，请联系<span class="err_tokf" @click="toKf">在线客服</span>
            </div>
          </div>

          <template v-if="item.status < 2 ||(item.status == 2 && item.local_video_url === null)">
            <!-- 绘画 中 -->
            <div class="detail_loading msg-item-content">
              <circleloading></circleloading>
              <div class="loading_text">
                正在全力生成视频中，请稍等...
                <span v-if="item.progress >0">{{ item.progress }}%</span>
              </div>
            </div>
          </template>
          <div v-if="item.status == 2 && item.local_video_url !== null" style="padding: 10px 0 0 0 ;">
            <div class="success_shouVideo">
              <video controlslist="nodownload"
                  role="application" controls
                  :poster="item.cover_url!=null?item.cover_url:''"
                  :preload="item.cover_url!=null?'none':'auto'" v-loading="true"
                  :src="item.local_video_url"
                  ref="videoPlayers"
                  @play="handlePlay(index)"
                  ></video>
              <div v-if="item.img_url !=null || item.img_url !=''" class="success_img"
                   :style="item.img_url ==null || item.img_url ==''?'display:none;':'display:;'">
                <!--                        <img :src="msg.img_url" @error="handleImageError(index)"  alt="" class="xianshi" >-->
                <img :src="item.img_url" alt="" class="xianshi">
                <div class="success_imgdel">
                  <div style="display: flex;align-items: flex-end;">
                            <span
                                style="background: #5865f2a8;border-radius: 3px;margin:  2px;padding: 0 4px;color: white">原图</span>
                  </div>
                  <div style="display: flex;flex-direction: column;padding: 2px 2px 0 0 ;">
                    <i class="el-icon-close yichang" @click="item.img_url = ''"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <popup ref="defeatPopup"
           type="center"
           @close="defeatPopClose">
      <div class="defeat_popup">
        <div class="popup_title">失败原因如下</div>
        <div class="popup_content">
          <div class="content_item">
            <div class="item_question">问：为什么Runway会比较慢？</div>
            <div class="item_answer">
              答：因为Runway与其他视频软件不同，本身为Ai绘制通常仅需约几分钟完成，算下来速度相当快！
            </div>
          </div>
          <div class="content_item">
            <div class="item_question">问：为什么绘制视频会提示失败？</div>
            <div class="item_answer">
              答：因为Runway绘制视频全部为Ai原创，可能会出现违规低俗内容，这些图片会被系统自动过滤删除，与您无关！
            </div>
          </div>
        </div>
        <button class="close_btn"
                @click="defeatPopClose">好的，我知道了
        </button>
      </div>
    </popup>
    <!-- 推荐到广场 -->
    <Recommend v-if="current_draw&&show_recommend_popup"
               :draw_item="current_draw"
               @close="recommendCallBack"
               ref="recommend"></Recommend>
    <!-- 分享 -->
    <ShareDraw v-if="current_draw&&show_sharedraw_popup"
               :draw_item="current_draw"
               @close="show_sharedraw_popup=false"
               ref="ShareDraw"></ShareDraw>


    <!-- 反馈弹窗 -->
    <FeedBack v-if="current_draw&&show_feedback_popup"
              :draw_item="current_draw"
              @close="show_feedback_popup=false"
              ref="feedback"></FeedBack>

    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
  </div>
</template>
<script type="text/ecmascript-6">
import popup from "COMPONENTS/Popup.vue"
import circleloading from "COMPONENTS/CircleLoading.vue"
import FeedBack from '@/components/FeedBack.vue'
import Recommend from '@/components/Recommend.vue'
import ShareDraw from '@/components/ShareDraw.vue'
import drawCateEdit from '@/components/DrawCateEdit'
import TipsWords from '@/components/TipsWords'
import faceVerifyPopup from "@/components/FaceVerifyPopu.vue";
import utils from "@/utils";

export default {
  components: {popup, circleloading, FeedBack, Recommend, ShareDraw, drawCateEdit, TipsWords, faceVerifyPopup},
  data() {
    return {
      //显示用户反馈
      show_feedback_popup: false,
      //显示推荐到广场
      show_recommend_popup: false,
      //显示分享弹窗
      show_sharedraw_popup: false,
      current_draw: null,//当前选中的记录
      draw_list: [],
      noMore: false, // 是否还有数据
      loading: false, // 正在请求数据
      max_mj_id: 0, // 最小的ID
      checkIds: [], // 生成中的需要检测的ID
      timer: null,
      sampleSysList: [], // 系统样例
      sampleUserList: [], // 用户样例
      sampleTimer: null,
      view_img_url: "",
      page: 1,
      useVideo: {list1: false, list2: false,},
      promptList1: [
        {
          ch: "电影级10秒保时捷911 Turbo S广告，展现风与自由的终极表达。一位30多岁的中国男性驾驶者，英俊自信，摇下车窗，狂风掀起他乌黑的发丝，脸上浮现放松而狂喜的微笑。场景设定在黄金时分的海岸悬崖公路，深蓝色海平线延向天际，夕阳将天空染成橙红色。开篇特写驾驶员陶醉的面部表情，戏剧性吊臂镜头拉开，展现保时捷在蜿蜒路上划出凌厉轨迹，慢动作捕捉车辆优雅过弯时，阳光在完美漆面上跃动的光斑。8K超清画质，ARRI Alexa拍摄，电影级调色，超现实主义质感。广告词使用中文表达，传递纯粹、野性的愉悦与解放感。 ",
          en: `A cinematic 10-second Porsche 911 Turbo S commercial, showcasing the ultimate expression of wind and freedom. A handsome, confident Chinese male driver in his 30s rolls down his window, with the wind tossing his jet-black hair as a relaxed, euphoric smile graces his face. The scene unfolds along a coastal cliff road at golden hour, with a deep blue horizon stretching into the sky, and the setting sun painting the sky in hues of orange-red. The opening close-up captures the driver's entranced expression, followed by a dramatic crane shot revealing the Porsche carving sharp lines through the winding road. Slow-motion footage captures the car's graceful cornering, with sunlight dancing in shimmering patterns across its perfect paintwork. Shot in 8K ultra-high definition with an ARRI Alexa camera, the commercial features cinematic color grading and a surrealist texture. The Chinese text slogan conveys pure, untamed joy and liberation.`
        }, {
          ch: "真人拍摄，现代都市异能短剧《战神觉醒》，暴雨中的摩天楼顶场景，主角（身高188cm穿着残破西装）站在天台边缘，闪电照亮他染血的侧脸。突然西装爆裂露出背后龙纹刺青，雨水在距离身体10cm处自动蒸发。采用360度环绕镜头，画面交替特写刺青觉醒过程与楼下跪拜的黑衣人群。冷蓝色调中穿插金色能量光效，暴雨声渐弱转为心跳声，当刺青完全亮起时，所有黑衣人齐声呐喊'三年之约已到，恭迎战神归来！'（中文台词带混响效果） ",
          en: `In the live action shooting, the modern urban power short play "Ares Awakening", the scene of the skyscraper roof in the rainstorm, the main character (188cm tall and wearing a torn suit) stands at the edge of the roof, and the lightning illuminates his bloody side face. Suddenly, the suit burst, revealing the dragon tattoo on the back, and rainwater evaporated automatically at a distance of 10cm from the body. Using a 360 degree surround camera, the image alternates between close-up shots of the tattoo awakening process and the black clad crowd kneeling downstairs. The cold blue color is interspersed with golden energy light effect, and the sound of rainstorm gradually turns into heartbeat. When the tattoo is fully lit, all the people in black shout in unison, 'The three-year appointment has arrived, and welcome the return of God of War! (Chinese dialogue with reverberation effect)`
        },
        {
          ch:"10秒电影级保时捷911 Turbo S电视广告文案‌（终极风与自由的表达） ‌画面‌：一位30多岁英俊自信的男性驾驶者摇下车窗，任由狂风掀起发丝，脸上浮现放松而狂喜的微笑。场景设定在黄金时分的海岸悬崖公路，深蓝色海平线延向天际。‌镜头语言‌：开篇特写驾驶员陶醉的面部表情戏剧性吊臂镜头拉开，展现保时捷在蜿蜒路上划出凌厉轨迹慢动作捕捉车辆优雅过弯时，阳光在完美漆面上跃动的光斑+技术参数‌：+ 8K超清画质｜ARRI Alexa拍摄｜电影级调色｜超现实主义质感 +‌内核‌：纯粹、野性的愉悦与解放感",
          en:`10-second Porsche 911 Turbo S TV commercial copy (the ultimate expression of wind and freedom) Picture: A handsome and confident man in his thirties, the driver, rolls down the car window, letting the wind tousle his hair, with a relaxed and ecstatic smile on his face. The scene is set on a coastal cliff road at golden hour, with the deep blue sea stretching towards the horizon. Cinematography: The opening shot is a close-up of the driver's intoxicated facial expression. The camera then pulls back dramatically to show the Porsche carving a sharp trajectory on the winding road. Slow-motion captures the light spots dancing on the perfect paint job as the vehicle elegantly takes the corner, bathed in sunlight. Technical parameters: 8K ultra-high-definition | shot with ARRI Alexa | film-grade color grading | surrealistic texture. Core: pure, wild pleasure and liberation.`
        },
        {
          ch:"白色洞洞鞋广告宣传视频，国际超模，时尚大片",
          en:`White Hole Hole Shoe Ad Prop Video, International Super Model, Fashion Big Hit`
        },
        {
          ch:"电影级实感丰田AE86电视广告‌画面‌：AE86在雨夜山道上华丽漂移，霓虹都市在背景中铺展如光之画卷。高速动态捕捉，车身倒映斑斓光影，黑色电影风格打光，致敬《头文字D》电影美学。核心元素‌：湿滑路面与轮胎摩擦的蒸汽特效车灯划破雨幕的丁达尔效应仪表盘红光与冷调环境光的赛博对比技术规格‌：4K HDR｜120fps升格拍摄｜胶片颗粒质感｜杜比全景声混音风格参考‌：《银翼杀手2049》×《头文字D》终极融合",
          en:`Toyota AE86 TV commercial with cinematic realism: AE86 performs a spectacular drift on a mountain road in the rain at night, with the neon-lit cityscape unfolding in the background like a canvas of light. High-speed dynamic capture shows the car's body reflecting a riot of colors and light. The black film style lighting pays homage to the aesthetic of the "Initial D" movie. Key elements: steam effects from the wet road and tire friction, Tyndall effect of the headlights piercing the rain curtain, and the cyber contrast of the red dashboard lights against the cool ambient light. Technical specifications: 4K HDR | 120fps slow-motion shooting | film grain texture | Dolby Atmos surround sound. Style references: "Blade Runner 2049" x "Initial D" ultimate fusion.`
        },
        {
          ch:"山姆·奥尔特曼穿着相声长袍说报菜名，内容如下：蒸羊羔、蒸熊掌、蒸鹿尾儿、烧花鸭、烧雏鸡、烧子鹅、炉猪、炉鸭、酱鸡、腊肉、松花、小肚儿、晾肉、香肠儿。什锦苏盘儿、熏鸡白肚儿、清蒸八宝猪、江米酿鸭子。罐儿野鸡、罐儿鹌鹑、卤什件儿、卤子鹅、山鸡、兔脯、菜蟒、银鱼、清蒸哈什蚂。烩腰丝、烩鸭腰、烩鸭条、清拌鸭丝儿、黄心管儿、焖白鳝、焖黄鳝、豆豉鲇鱼、锅烧鲤鱼、锅烧鲶鱼、清蒸甲鱼、抓炒鲤鱼、抓炒对虾、软炸里脊、软炸鸡。什锦套肠儿、麻酥油卷儿、卤煮寒鸦儿、熘鲜蘑、熘鱼脯、熘鱼肚、熘鱼骨、熘鱼片儿、醋熘肉片儿。烩三鲜儿、烩白蘑、烩全饤儿、烩鸽子蛋、炒虾仁儿、烩虾仁儿、烩腰",
          en:`Sam Altman, dressed in a traditional Chinese opera costume, recited a list of dishes as follows: steamed lamb, steamed bear paws, steamed deer tails, roast duck, roast chicken, roast goose, roast pork, roast duck, braised chicken, cured meat, smoked duck, sausages, small intestine, dried meat, sausages. Assorted cold dishes, smoked chicken and white duck, steamed eight-treasure pork, glutinous rice-stuffed duck. Wild chicken in a jar, quail in a jar, assorted braised dishes, braised goose, pheasant, rabbit breast, vegetable snake, silver fish, steamed turtle. Stewed shredded kidney, stewed duck kidneys, stewed duck strips, cold mixed duck fillets, yellow heart tubes, braised white eel, braised yellow eel, black bean sauce catfish, pan-fried carp, pan-fried catfish, steamed turtle, stir-fried carp, stir-fried prawns, soft-fried pork fillet, soft-fried chicken. Assorted stuffed intestines, sesame oil rolls, braised jackdaws, sautéed fresh mushrooms, sautéed fish fillets, sautéed fish maws, sautéed fish bones, sautéed fish slices, vinegar sautéed pork slices. Stewed three delicacies, stewed white mushrooms, stewed assorted dishes, stewed pigeon eggs, stir-fried shrimp, stewed shrimp, stewed kidneys.`,
        },
        {
          ch:"山姆·奥尔特曼你说说为什么不给安卓上架个sora app，普通话说",
          en:`Sam Altman, tell me why you don't put a Sora app on Android. Speak in Mandarin`
        },
        {
          ch:"山姆·奥尔特曼用中文讲相声，不用自我介绍，直接讲段子",
          en:`Sam Altman performs cross talk in Chinese, without the need for self-introduction, directly delivering jokes`
        },
        {
          ch:"我的AirPod Pro充电盒晃动了一下，然后四肢和机械头突然弹出，接着它站起来走掉了。",
          en:`My AirPod Pro charging case shook briefly, and then its limbs and mechanical head suddenly popped out. After that, it stood up and walked away.`
        },
        {
          ch:"小猫泡澡，香香水果薄荷浴",
          en:`A cat is bathing in a pool of warm, refreshing water with a sprinkle of mint and a squeeze of fresh fruits.`
        },
        {
          ch:"坐在月球上的咖啡馆里。这是一间温馨而极简的咖啡馆，暖色调的灯光。手边只有一杯咖啡和一台笔记本电脑。窗外是地球。山姆转向镜头说：‘这里的Wi-Fi得升级一下’。",
          en:`Sitting in a café on the moon. This is a cozy and minimalist café, with warm-toned lighting. All I have at hand is a cup of coffee and a laptop. Outside the window is Earth. Sam turns to the camera and says, 'The Wi-Fi here needs an upgrade.'`
        },
      ],
      promptList2: [
          {
            ch: "音乐MV，城市流行。少女唱着中文流行歌曲，乘坐出租车眺望窗外，窗外下着雨，夜晚的街道飞驰而过。",
            en: `Music MV, urban pop. The girl sang Chinese pop songs, took a taxi and looked out the window. It was raining outside, and the streets were speeding by at night.`
          },
          {
            ch: "深夜的极简主义工作台上，一个AirPod Pro充电盒突然高频震动，金属外壳如花瓣般优雅展开，精密齿轮与液压杆协同运作，瞬间组装成1.2米高的类人机器人。机械体采用钛合金骨架与半透明聚合物外壳，内部电路发出幽蓝脉冲光。机器人以猫科动物般的敏捷跃下桌面，在冷调月光与霓虹灯带交织的实验室穿行，经过全息投影界面时触发数据流涟漪。镜头采用Steadicam稳定器跟拍，配合0.5倍速子弹时间特效，突出机械关节的液压运作细节与碳纤维肌腱的伸缩。主光源为2700K色温的隐藏式射灯，在抛光金属表面形成动态高光，环境光采用HDR渲染的赛博朋克青橙色调。",
            en: `On the minimalist workbench in the late night, an AirPod Pro charging case suddenly vibrates at high frequency, and the metal shell elegantly unfolds like a flower petal. Precise gears and hydraulic rods work together to instantly assemble into a 1.2-meter-high humanoid robot. The mechanical body adopts a titanium alloy skeleton and a semi transparent polymer shell, and the internal circuit emits a faint blue pulse light. The robot jumps off the desktop with feline like agility, navigating through a laboratory interwoven with cool moonlight and neon lights, triggering ripples in the data stream as it passes through the holographic projection interface. The camera adopts Steadicam stabilizer for follow-up shooting, combined with 0.5x bullet time effect, highlighting the hydraulic operation details of mechanical joints and the extension and contraction of carbon fiber tendons. The main light source is a hidden spotlight with a color temperature of 2700K, which creates dynamic highlights on the polished metal surface. The ambient light is rendered in HDR cyberpunk green orange tones.`
          }, {
            ch: "中国女主播在珠穆朗玛峰大本营，身着最新款高科技羽绒服面对手机镜头直播。她一边展示服装的防风防水功能，一边与观众互动。背景可见登山队员和帐篷，镜头在主播近景和雪山全景间切换。夕阳的余晖为画面镀上金色，整体氛围既专业又充满极限挑战的刺激感。",
            en: `Chinese female anchor, dressed in the latest high-tech down jacket, is live streaming in front of the phone camera at the Everest base camp. She demonstrated the windproof and waterproof functions of the clothing while interacting with the audience. The background shows mountaineers and tents, and the camera switches between the anchor's close-up and the panoramic view of the snow capped mountains. The afterglow of the sunset paints the picture with gold, creating a professional and thrilling atmosphere full of extreme challenges.`
          },
        {
          ch:"4只猫在打麻将，忽然打了起来",
          en:`Four cats are playing mahjong, and then one of them starts to play.`
        },
        {
          ch:"穿越回17世纪，和牛顿在伦敦的一家古老酒吧里聊天。历史上的牛顿，不仅发现了地心引力，还和我开起了玩笑。",
          en:`In the 17th century, I met Newton at an old bar in London. Newton not only discovered the theory of gravity, but also had a good time with me.`
        },
        {
          ch:"换成蚂蚁爬在草丛中找吃的",
          en:`A ant is crawling in a field, looking for food.`
        },
        {
          ch:"人类vs动物。Sora 2逼真度全面展示，每个动作和机位都像真实拍摄。",
          en:`Human vs. animal. Sora 2 showcases its realistic degree comprehensively, with each action and shot looking like a real shot.`
        },
        {
          ch:"小猫理发师在给中国男人理发，手滑把头发理成了秃子，中国男人气愤地追小猫理发师",
          en:`A cat barber is giving a man in China a haircut, but he accidently scrunched the hair into a ponytail. The man is angry at the cat barber.`
        },
        {
          ch:"一位美得令人窒息、五官优雅的女子，在金色时节，站在樱花雨下，长发被风轻轻扬起。她接住一片飘落的花瓣，轻轻一笑，凝视着眼前男子的双眼——爱意在她眼中闪耀。",
          en:`A beautiful woman, with graceful features and long hair, is standing in the golden season, under a sakura rain. Her long hair is lightly blown by the wind. She catches a falling petal, smiles, and gazes at the eyes of the man in front of her — the love is shining in her eyes.`
        },
        {
          ch:"音乐MV，城市流行。少女乘坐出租车眺望窗外，窗外下着雨，夜晚的街道飞驰而过。",
          en:`A music MV, city-pop. A beautiful girl is driving a taxi to look at the window outside. The window is covered with rain, and the city streets are flashing at night.`
        },
      ]

    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    sora_model() {
      return this.$store.state.sora_model;
    },
  },
  created() {
    console.log(1111111)
    this.sampleUserList = JSON.parse(localStorage.getItem('sampleUserList') || "[]")

    this.fetchDataList()
  },
  methods: {
    error_new_fn(id, index) {
      this.draw_list[index].regenLoading = 1
      this.$forceUpdate()
      this.$http.post('/front/aivideo/retry/', {id}).then(res => {
        this.draw_list[index].regenLoading = 0

        if (res.status == 200) {
          this.$message.success('重新生成创建成功')
          this.scrollToTop()
          this.draw_list[index].is_retry = 1
          this.draw_list.unshift(res.data.video)
          this.checkIds.push(res.data.video.id)
          this.fetchMsg()
        } else {
          let message = res.message;
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "expired_gift_score") {
            // 队列已满
            this.$confirm('您的积分已过期，如需继续使用该功能请购买积分或升级套餐', '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_face_verify") {
            // 实名认证
            this.$refs.faceVerifyPopup.show()
            return
          } else if (message == 'retry_num_max') {
            message = '已超出最大重试次数'
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
          })
        }
      }).catch(res => {
        this.draw_list[index].regenLoading = 0

        let message = res.message;
        if (message == "vip_expire") {
          // VIP 过期了
          this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
            this.$router.push('/member')
          }).catch(() => {

          });
          return
        } else if (message == "no_open_vip") {
          // 未开通 VIP
          this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
            this.$router.push('/member')
          }).catch(() => {

          });
          return
        } else if (message == "no_gift_score") {
          // 积分不足
          this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
            this.$router.push('/member')
          }).catch(() => {

          });
          return
        } else if (message == "expired_gift_score") {
          // 队列已满
          this.$confirm('您的积分已过期，如需继续使用该功能请购买积分或升级套餐', '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push('/member')
          }).catch(() => {

          });
          return
        } else if (message == "upgradevip") {
          // 队列已满
          this.$confirm(res.data.msg, '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
            this.$router.push('/member')
          }).catch(() => {

          });
          return
        } else if (message == "no_face_verify") {
          // 实名认证
          this.$refs.faceVerifyPopup.show()
          return
        } else if (message == 'retry_num_max') {
          message = '已超出最大重试次数'
        }
        if (message.indexOf("您提问的内容包含违禁词") > -1) {
          message = "内容可能违反国家政策，请重新输入";
        }
        this.$confirm(message, '提示', {
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
        })
      }).finally(() => {

      })
    },
    toKf() {
      utils.tokf()

      // window.open('/linkus')
    },
    getUserSample() {
      this.sampleSysList.unshift(JSON.parse(localStorage.getItem('sampleUserList')))
      this.sampleTimer = setInterval(() => {
        let createNum = 0; // 需要生成个数
        this.sampleSysList.forEach(e => {
          if (e.progress < 100) {
            createNum += 1
            let num = parseInt(Math.random() * 10);
            if (e.progress + num > 100) {
              e.progress = 100
              e.status = 2
              localStorage.removeItem('semText')
              localStorage.removeItem('sampleNa')
              localStorage.setItem("sampleUserList", JSON.stringify(this.sampleUserList))
              this.sampleUserList.forEach(m => {
                if (e.draw_id == m.draw_id) {
                  e.progress = 100
                  localStorage.setItem("sampleUserList", JSON.stringify(this.sampleUserList))
                }
              })
              this.scrollToTop()
            } else {
              e.progress += num
            }
          }
        })
        // if (createNum == 0) {
        //   clearInterval(this.sampleTimer)
        //   this.sampleTimer = null
        //   this.scrollToTop()
        // }
      }, 500)
    },
    fettchSampleList() {
      // 获取样例数据
      let promptList = this.sora_model == 2 ? this.promptList1:this.promptList2
      promptList.forEach((e, i) => {
        this.sampleSysList.push({
          tempListobj: 1,
          add_time: utils.getRandomTimeToday(),
          again_prompt: "",
          ctype: 2,
          data_json: {
            cover_image_urls: [`https://faceswap8.oss-cn-beijing.aliyuncs.com/sora/example/sample/promptList${this.sora_model==1?2:1}/${i + 1}.1.mp4`,],
            image_urls: [`https://faceswap8.oss-cn-beijing.aliyuncs.com/sora/example/sample/promptList${this.sora_model==1?2:1}/${i + 1}.1.mp4`,]
          },
          down_status: 1,
          down_time: utils.getRandomTimeToday(),
          id: 950,
          cover_url: `https://faceswap8.oss-cn-beijing.aliyuncs.com/sora/example/sample/promptList${this.sora_model==1?2:1}/${i + 1}.2.webp`,
          video_url: `https://faceswap8.oss-cn-beijing.aliyuncs.com/sora/example/sample/promptList${this.sora_model==1?2:1}/${i + 1}.1.mp4`,
          output_url: `https://faceswap8.oss-cn-beijing.aliyuncs.com/sora/example/sample/promptList${this.sora_model==1?2:1}/${i + 1}.2.webp`,
          text_prompt: e.en,
          text_prompt_cn:e.ch,
          status: 2,
          template_id: 0,
        })
      })
    },

    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)
          this.$store.commit('setShowLogin', true)
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }
    },

    loadMore() {
      // 加载更多数据
      this.noMore = true
      this.loading = true
      if (this.isLogin) {
        // 登录请求样例
        if (this.useVideo.list1) {
          if (!this.useVideo.list2) {
            this.useVideo.list2 = true
            this.$message.warning('视频已全部加载')
          }
        } else {
          this.page++;
          this.fetchDataList()
        }
      } else {
        // 未登录请求样例
        // this.pageType = false
        if (!(this.sampleSysList.length % 10 === 0)) {
          this.$message.warning('样例已全部加载')
          return
        }
        this.page = this.page + 1
        if (this.page == 4) {
          this.$message.warning('样例已全部加载')
          return;
        }
        if (this.page > 4) {
          return
        }
        this.fettchSampleList()
      }
    },
    fetchDataList() {
      // 对话内容
      console.log('this.sora_model',this.sora_model)
      this.loading = true
      this.$http.get(`/front/aivideo/user/video/?page=${this.page}`, {
        params: {max_mj_id: this.max_mj_id,soft: 8,
          model_version:this.sora_model==1?'sora2':'sora2_pro'},
        page: this.page,
        size: 10,
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.item_list.length > 0) {

            if (this.max_mj_id == 0) {
              res.data.item_list.forEach(e => {
                if (e.status <= 1 || (e.status == 2 && e.local_video_url == null)) {
                  this.checkIds.push(e.id)
                }
              })
              this.fetchMsg()
            }

            this.max_mj_id = res.data.item_list[res.data.item_list.length - 1].draw_id
            this.draw_list = this.draw_list.concat(res.data.item_list)
            this.draw_list.forEach(item => {
              if (item.regenLoading != 1) {
                item.regenLoading = 0
              }
            })
            // this.draw_list[0].status = 3
            // this.draw_list[0].show_error = 1
            // this.draw_list[0].is_retry = 0
            // this.draw_list[0].retry_num = 1
          } else {
            this.noMore = true
            this.useVideo.list1 = true
            if (this.max_mj_id == 0) {
              this.fettchSampleList()
            }

          }
        } else {
          this.fettchSampleList()
        }
      }).finally(() => {
        this.loading = false
      })
    },

    fetchMsg() {
      if (this.checkIds.length == 0) {
        return
      }
      if (this.timer) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        this.$http.post('/front/aivideo/check/', {ids: this.checkIds}).then((res) => {
          if (res.status == 200) {
            let item_list = res.data.item_list;
            let draw_id = 0;
            item_list.forEach(e => {
              draw_id = e.id
              let item = this.draw_list.filter((obj) => obj.id == draw_id)[0];

              item.status = e.status
              item.is_public = 0
              item.img_url = e.img_url
              item.progress = e.progress
              item.text_prompt = e.text_prompt
              item.text_prompt_cn = e.text_prompt_cn
              let num = parseInt(Math.random() * 10);
              if (item.progress + num > 100) {
                item.progress = 100
              } else {
                item.progress += num
              }

              // item.img_url = e.img_url;
              if (e.status > 2) {
                // 删除生成成功或失败的
                item.show_error = e.show_error
                if (e.show_error) {
                  this.$message.error(e.show_error)
                }
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
              }
              if (e.status == 2 && e.local_video_url != null) {
                // 生成成功 并下载本地
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
                item.local_video_url = e.local_video_url
                item.cover_url = e.cover_url
                item.img_url = e.img_url

                this.scrollToTop();
                // 创作成功检测是否弹出挽留弹窗
                utils.checkContinuePop(this.$store.state.userInfo)
              }
              if (e.status === 3) {
                // 失败
                console.log('shibai')
                console.log(e)
                this.draw_list.forEach((_list, num) => {
                  if (_list.id == e.id) {
                    this.draw_list[num] = e
                  }
                })
              }
              if (e.status == 3 && e.show_error_message) {
                this.$message.error(e.error_message)
              }
            })
          }
          if (this.checkIds.length == 0) {
            clearInterval(this.timer);
          }
        }).catch((res) => {
          clearInterval(this.timer);
        })
      }, 3000)
    },

    scrollToTop() {
      this.$nextTick(() => {
        let scrollWrap = this.$refs.scrollWrap;
        scrollWrap.scrollTop = 0;
      })
    },
    delete_draw_list(id, index) {
      // 删除
      this.$confirm('确定删除该创作记录吗，删除后不可恢复？', '提示', {
        type: 'warning',
        customClass: 'confirm_box'
      }).then(() => {
        this.$http.delete(`/front/aimj/draw/${id}/`).then((res) => {
          this.draw_list.splice(index, 1)
        })
      })

    },
    showDefeatPopup() {
      this.$refs.defeatPopup.show();
    },
    defeatPopClose() {
      this.$refs.defeatPopup.close();
    },


    sample_btn(name) {
      if (!this.checkLogin()) {
        return
      }

      if (name == 'del') {
        this.$message({
          message: '样例数据不能删除！请创作后重试。',
          type: 'warning'
        });
      } else {
        this.$message({
          message: '样例数据不能推荐到广场！请创作后重试。',
          type: 'warning'
        });
      }
    },
    deleteVideo(index, msg) {
      this.$confirm('确定删除该创作记录吗，删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.delete(`/front/aivideo/${msg.id}/`).then(res => {
          if (res.status == '200') {
            this.$message.success('删除成功')
            this.draw_list.splice(index, 1)
          }
        })
      })
    },
    recommend(video_id, index) {
      if (!this.checkLogin()) {
        return
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/member')
        })
        return false
      }
      this.$http.patch('/front/aivideo/user/video/' + video_id + '/', {
        action: "public",
        data: {sys_cate_id: 1}
      }).then(res => {
        if (res.status === '200') {
          this.$message({
            message: '推荐成功，请等待审核！',
            type: 'success'
          });
          this.draw_list[index].is_public = 1

        } else {
          this.$message.error(res.message)
        }
      }).catch(res => {
        this.$message({
          message: res.message,
          type: 'error'
        });
      }).finally(() => {
        this.sendLoading = false
      })
    },
    // 视频播放暂停 仅一个视频播放
    handlePlay(index) {
      this.$nextTick(() => {
        const videoPlayers = this.$refs.videoPlayers;
        videoPlayers.forEach((item, num) => {
          if (num != index) {
            videoPlayers[num].pause();
          } else {
            videoPlayers[num].play();
          }
        })
      });
    },
    //用户视频下载
    downloadVideo(is_video,) {
      // return
      if(is_video=='sample'){
        this.$message.warning('当前样例不可下载，请生成后重试！')
        return
      }
      this.$http.get(`/front/aivideo/download/${is_video.id}/?soft=1`,).then(res => {
        if (res.status == '200') {
          window.location.href = res.data.url
        } else {
          let message = res.message;
          utils.createErrTip(message)
        }
      }).catch(err=>{
        let message = err.message;
        utils.createErrTip(message)
      }).finally(() => {
        this.loading = false
      })

    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = null;
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.error_new_btn {
  color: #56b15b;

  .err_succ_text {
    color: #ccc;
  }
}

.err_new_tip {
  color: #ccc;
  margin-top: 20px;

  .err_tokf {
    color: red;
  }
}

.draw_scroll {
  background-color: #313338;
  height: calc(100% - 15px);
  overflow-y: auto;
  color: #fff;

  &::-webkit-scrollbar {
    margin-left: 5px !important;
    display: block !important;
    width: 6px !important;
  }

  &::-webkit-scrollbar-thumb {
    height: 30px !important;
    background-color: #777 !important;
    border-radius: 10px !important;
  }

  .draw_list {
    overflow: hidden;
    width: 100%;
    position: relative;


    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 7px;
      cursor: pointer;
    }

    .draw_list_item {
      padding-bottom: 5px;
      background: #403d38;
      border-left: 2px solid #f0b132;
      margin: 10px 0;

      .text {
        padding: 10px;
        overflow: hidden;
        word-break: break-all;
        white-space: normal;
        line-height: 20px;
        flex: 1;

        .title {
          font-size: 12px;
          margin-bottom: 10px;

          .info {

            .topic {
              font-size: 14px;
              margin-right: 10px;
            }

            .tag {
              display: inline-block;
              //line-height: 24px;
              background-color: #5865f280;
              color: #fff;
              font-size: 12px;
              padding: 0 5px;
              border-radius: 4px;

              white-space: nowrap;
            }

            .time {
              color: #707070;
            }
          }

          .more_btn {
            width: 36px;
            height: 24px;
            border-radius: 4px;
            color: #fff;
            font-size: 16px;
            background-color: #1e1f22;
          }

          .delete {
            cursor: pointer;
            margin-left: 8px;
            color: #949ba4;

            img {
              width: 20px;
              height: 20px;
              margin-top: -2px;

              &.share {
                width: 16px;
                height: 16px;
              }
            }
          }
        }

        .top_right {
          display: flex;
          align-items: center;
          white-space: nowrap;
          margin-left: 8px;
          color: #949ba4;
          cursor: pointer;

          div:hover {
            color: #fff;
          }

          .el-icon-delete {
            font-size: 14px;
            margin-right: 3px;
          }
        }

        .desc {
          p {
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            line-clamp: 3;
          }

          .en {
            padding-top: 10px;
            margin-top: 10px;
            color: #999168;
            border-top: 1px solid #555041;
          }
        }
      }

      .big_img {
        margin-top: 10px;

        .el-image {
          width: 200px;
        }
      }

      .options {
        .options_list {
          margin-top: 10px;

          .tips_icon {
            width: 14px;
            height: 14px;
            opacity: 0.5;
          }

          span {
            font-size: 13px;
            width: 58px;
            height: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            background: #4e5058;
            margin-left: 8px;
            border-radius: 3px;
            cursor: pointer;

            img {
              width: 18px;
              height: 18px;
            }

            &:hover {
              background: #6e717c;
            }

            &.span {
              width: 100px;

              img {
                margin-right: 5px;
              }
            }

            &.span2 {
              width: 40px;
            }
          }

          //
          .redraw {
            img {
              height: 20px;
              // margin-top: 5px;
            }

            line-height: 32px;
          }

          .btn {

            &:not(:last-child) {
              margin-right: 0px;
            }

            &.loading {
              opacity: 0.6;

              svg {
                margin-top: -4px;
                vertical-align: middle;
                margin-right: 4px;
                animation: rotate 2s linear infinite;
              }
            }

            &.redraw2 {
              background-color: #f5f6fb;

              img {
                height: 30px;
              }
            }

            &.disabled {
              cursor: not-allowed;
              background-color: #ddd;
              color: #666;
            }
          }

          //
        }
      }
    }
  }
}

.tooltips_text {
  font-size: 14px;
  line-height: 1.7;
}

.create_error {
  width: 220px;
  height: 230px;
  padding: 0 10px;
  background-color: #fff;
  border-radius: 4px;
  padding-top: 28px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;

  .error_icon {
    display: block;
    width: 35px;
    margin: 0 auto;
  }

  .error_text {
    color: #ccc;
    line-height: 34px;
  }

  .error_btn {
    display: inline-block;
    cursor: pointer;
    color: #ffab46;
    padding-top: 15px;
  }
}

.success_shouVideo {
  position: relative;
  width: 100%;
  height: 200px;
  background-color: #080707;

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%; /* 设置视频宽度为父容器的100% */
    height: 100%; /* 保持视频的宽高比 */
  }

  .success_img {
    position: absolute;
    display: inline-block;
    top: 5px;
    right: 5px;
    border: 1px solid #FFF;
    width: 85px;

    img {
      display: block;
      width: 85px; /* 根据需要调整图片宽度 */
      height: auto;
      cursor: pointer;
    }

    img:hover .success_imgdel {
      position: absolute;
      top: 0; /* 调整图标距离顶部的距离 */
      right: 0; /* 调整图标距离右侧的距离 */
      border-radius: 50%; /* 使图标背景为圆形 */
      font-size: 18px; /* 根据需要调整图标字体大小 */
      color: #333; /* 图标颜色 */
      cursor: pointer;
      //display: none;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 100%;
    }

    .success_imgdel {
      position: absolute;
      top: 0; /* 调整图标距离顶部的距离 */
      right: 0; /* 调整图标距离右侧的距离 */
      border-radius: 50%; /* 使图标背景为圆形 */
      font-size: 18px; /* 根据需要调整图标字体大小 */
      color: #333; /* 图标颜色 */
      cursor: pointer;
      //display: none;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 100%;

      span {
        font-size: 12px;
      }

      i {
        font-size: 12px;
        background-color: #fff;
        border-radius: 50%;
      }
    }

    .success_imgdel:hover {
      color: white;

      i {
        font-size: 12px;
        background-color: #2b2d31;
        border-radius: 50%;
      }
    }

  }
}


.defeat_popup {
  width: 360px;
  padding: 0 30px 36px;
  background-color: #fff;
  border-radius: 10px;

  .popup_title {
    font-size: 16px;
    font-weight: bold;
    line-height: 60px;
    text-align: center;
    color: black;
  }

  .popup_content {
    padding-bottom: 10px;

    .content_item {
      padding-bottom: 18px;
      font-size: 13px;
      line-height: 25px;

      .item_answer {
        white-space: wrap;
        color: #999;
      }

      .item_question {
        width: 100%;
        white-space: wrap;
        color: #000;
      }
    }
  }

  .close_btn {
    width: 240px;
    height: 50px;
    border: none;
    border-radius: 5px;
    background-color: #5865f2;
    color: #fff;
    font-size: 15px;
    display: block;
    margin: 0 auto;
  }
}

.msg-item-content {
  font-size: 13px;
  line-height: 20px;
  padding-top: 5px;

  &.detail_loading {
    .remove_icon {
      // display: none;
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("../img/update_close.png");
      background-color: rgba(100, 100, 100, 0.6);
      cursor: pointer;
      border-radius: 3px;
    }

    .loading_text {
      padding-left: 12px;
      color: #f0b132;
    }
  }
}

.creating_progress {
  margin-top: 15px;
  display: flex;
  align-items: center;
  width: 360px;

  .progress_bar {
    flex-grow: 1;
    height: 10px;
    border-radius: 5px;
    background-color: #dbefe4;
    margin-right: 6px;

    .progress_line {
      height: 100%;
      background-color: #f0b132;
      border-radius: 5px;
      transition: width 0.3s linear;
    }
  }

  .progress_percent {
    font-size: 12px;
    line-height: 1;
    color: #f0b132;
    white-space: nowrap;
  }
}

.msg_img_wrap {
  max-width: 400px;
  position: relative;
  overflow: hidden;
  display: inline-block;
  // border-radius:5px;
  &:hover {
    .img_footer {
      bottom: 0;
    }
  }

  .msg_img_ele {
    display: block;
    width: 100%;
    cursor: pointer;
  }

  .img_footer {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: -40px;
    height: 40px;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: space-around;
    transition: bottom 0.3s;

    .footer_item {
      cursor: pointer;

      .footer_icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-right: 5px;
        background-size: 100% 100%;

        &.download {
          background-image: url("../img/download.png");
        }

        &.preview {
          background-image: url("../img/preview_img.png");
        }

        &.delete {
          background-image: url("../img/remove.png");
        }
      }

      span {
        vertical-align: middle;
        display: inline-block;
        font-size: 14px;
        color: #fff;
      }
    }
  }

  .look_img {
    //display: none;
    //opacity: 0;
    cursor: pointer;
    width: 75px;
    height: 28px;
    position: absolute;
    top: 10px;
    right: 10px;
    border: rgba(88, 101, 242, 0.8) solid 2px;
    background-color: rgba(88, 101, 242, 0.533);
    border-radius: 6px;
    color: white;
    font-size: 12px;
    box-sizing: border-box;
    line-height: 24px;
    text-align: center;
  }
}

.more_list {
  .operate_item {
    height: 28px;
    font-size: 14px;
    color: #949ba4;

    img {
      width: 20px;
      height: 20px;
      margin-top: -2px;
      margin-right: 4px;

      &.share {
        width: 14px;
        height: 14px;
        margin-left: 3px;
        margin-right: 6px;
      }
    }
  }
}
</style>